import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { MdLanguage, MdOutlineAssignment } from 'react-icons/md';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { a11yProps, CustomTabPanel } from 'components/Common/CustomTabPanel';
import BusinessKnowledgeIcon from 'assets/icons/BusinessKnowledgeIcon';
import QAIcon from 'assets/icons/QAIcon';
import QuestionAnswer from './components/QuestionAnswer';
import BusinessKnowledge from './components/BusinessKnowledge';
import AgentDatasets from './components/AgentDatasets';

export default function Knowledge() {
  const navigate = useNavigate();
  const location = useLocation();

  const getTabIndexFromUrl = () => {
    const params = new URLSearchParams(location.search);
    const tabIndex = params.get('tab');
    return tabIndex ? Number(tabIndex) : 0;
  };

  const [value, setValue] = useState<number>(getTabIndexFromUrl);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    navigate({
      pathname: location.pathname,
      search: `?tab=${newValue}`
    });
  };

  return (
    <>
      <Box bgcolor='background.paper' mb={3} py={0.5} px={1}>
        <Tabs value={value} onChange={handleChange} aria-label='knowledge tabs'>
          <Tab
            label={
              <Box display='flex' gap={1}>
                <QAIcon />
                Q&A
              </Box>
            }
            {...a11yProps('knowledge-tab', 'knowledge-tabpanel', 0)}
          />
          <Tab
            label={
              <Box display='flex' gap={1}>
                <MdLanguage style={{ fontSize: 20 }} />
                Web
              </Box>
            }
            {...a11yProps('knowledge-tab', 'knowledge-tabpanel', 1)}
          />
          <Tab
            label={
              <Box display='flex' gap={1}>
                <MdOutlineAssignment style={{ fontSize: 20 }} />
                Documents
              </Box>
            }
            {...a11yProps('knowledge-tab', 'knowledge-tabpanel', 2)}
          />
          <Tab
            label={
              <Box display='flex' gap={1}>
                <BusinessKnowledgeIcon />
                Business Knowledge
              </Box>
            }
            {...a11yProps('knowledge-tab', 'knowledge-tabpanel', 3)}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} id='knowledge-tab' ariaControl='knowledge-tabpanel' index={0}>
        <QuestionAnswer />
      </CustomTabPanel>
      <CustomTabPanel value={value} id='knowledge-tab' ariaControl='knowledge-tabpanel' index={1}>
        <AgentDatasets type='website' />
      </CustomTabPanel>
      <CustomTabPanel value={value} id='knowledge-tab' ariaControl='knowledge-tabpanel' index={2}>
        <AgentDatasets type='document' />
      </CustomTabPanel>
      <CustomTabPanel value={value} id='knowledge-tab' ariaControl='knowledge-tabpanel' index={3}>
        <BusinessKnowledge />
      </CustomTabPanel>

      <Outlet />
    </>
  );
}
